import { getGamePath } from '@/shared/libs/get-game-path';

type GamePathSource = Parameters<typeof getGamePath>[0];

export function getLocalizedGamePath(
  locale: string,
  game: GamePathSource
): string {
  return `/${locale}${getGamePath(game)}`;
}
